// Copyright ©️ 2026 eVolve MEP, LLC

import React, { useState } from 'react';

import { TwoPanelLayout } from 'app/Layout/TwoPanelLayout';
import { NoContentFallback } from 'components/NoContentFallback/NoContentFallback';
import { isNotNil } from 'helpers/isNotNil';
import { EditableWrapper } from 'modules/Admin/Facilities/EditableWrapper';
import { FacilitiesTable } from 'modules/Admin/Facilities/FacilitiesTable';
import type { FacilityActionModalState } from 'modules/Admin/Facilities/FacilityActionModals';
import { FacilityDetailsPane } from 'modules/Admin/Facilities/FacilityProperties/FacilityDetailsPane';

export const FacilitiesPage = () => {
  const [facilityAction, setFacilityAction] = useState<FacilityActionModalState | null>(null);
  return (
    <EditableWrapper localStorageKey="LAST_VIEWED_FACILITY">
      {({ selectItem: selectFacility, editing, setEditing, selectedItem: selectedFacility }) => (
        <TwoPanelLayout
          mainPanel={
            <FacilitiesTable
              facilityAction={facilityAction}
              setFacilityAction={setFacilityAction}
              selectFacility={selectFacility}
              selectedFacility={selectedFacility}
              editing={editing}
            />
          }
          detailPanel={
            isNotNil(selectedFacility) ? (
              <FacilityDetailsPane
                actionFacility={setFacilityAction}
                selectedFacility={selectedFacility}
                onFacilityUpdated={(f) => selectFacility(f, true)}
                editing={editing}
                setEditing={setEditing}
              />
            ) : (
              <NoContentFallback message="Select a facility." />
            )
          }
        />
      )}
    </EditableWrapper>
  );
};
